import { FC } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { ErrorIcon, ShieldIcon, SuccessIcon } from '../icons/icons';
import OddsCustomMessage from './OddsCustomMessage';
import 'react-toastify/dist/ReactToastify.css';

const Notification: FC = () => {
	return (
		<ToastContainer
			position='top-center'
			autoClose={2000}
			hideProgressBar
			newestOnTop={false}
			closeOnClick
			rtl={false}
		/>
	);
};

type NotificationType = 'success' | 'error';

export const notify = (message: string, type?: NotificationType, options: any = {}) => {
	// Check the "dontShowNotes" flag in localStorage
	const dontShowNotes = localStorage.getItem('dontShowNotes') === 'true';

	if (dontShowNotes && options.styeType) {
		// If "Don't Show Again" is true, skip showing the custom message
		return;
	}
	const msg = options.styeType ? (
		<OddsCustomMessage />
	) : (
		`${(message[0] as string).toUpperCase()}${message.substr(1)}`
	);

	options = {
		icon: true,
		autoClose: options.styeType ? false : 2000, // Disable autoClose when styeType is true
		style: {
			...options.style,
			color: '#3D3D3D',
			fontSize: '14px',
			fontWeight: '600',
			lineHeight: '125%',
			borderRadius: '12px',
			background: '#FFF2DF',
			boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.15)',
			padding: '16px'
		},
		...options
	};

	if (type === 'success') {
		toast.success(msg, {
			...options,
			icon: options.styeType ? ShieldIcon : SuccessIcon,
			toastId: 'success'
		});
	} else if (type === 'error') {
		toast.error(msg, { ...options, icon: ErrorIcon, toastId: 'error' });
	} else {
		toast(message, options);
	}
};

export default Notification;
